import React from 'react'
import PropTypes from 'prop-types'

// @material-ui
import { Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

// core
import { withLang } from '_core/hocs/withLang'

// style
import { verifyPassportStepInfoStyle } from './verifyPassportStepInfoStyle'

const RawVerifyPassportStepInfo = props => {
  const { classes, getLangString: l } = props

  return (
    <div className={classes.root}>
      <Typography variant="body2">
        {l('r._.profile.verify.passport.text.infotitle')}
      </Typography>

      <Typography variant="caption" gutterBottom={true}>
        {l('r._.profile.verify.passport.text.infobody')}
      </Typography>
    </div>
  )
}

RawVerifyPassportStepInfo.defaultProps = {
  time: 60,
}

RawVerifyPassportStepInfo.propTypes = {
  // `withStyles` HOC props
  classes: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const VerifyPassportStepInfo = withLang(
  withStyles(verifyPassportStepInfoStyle)(RawVerifyPassportStepInfo)
)
